/** Optional profile fields the user may finish later in Settings. */
export function getIncompleteSetupItems(settings) {
  if (!settings) return [];
  const items = [];
  if (!settings.business_logo) {
    items.push({ key: "logo", label: "business logo" });
  }
  if (!settings.owner_phone?.trim()) {
    items.push({ key: "phone", label: "phone number" });
  }
  if (!settings.business_address?.trim()) {
    items.push({ key: "address", label: "business address" });
  }
  const hasBank = !!settings.bank_account_number?.trim();
  const hasCard =
    !!settings.card_number?.replace(/\D/g, "") &&
    !!settings.card_expiry?.trim();
  if (!hasBank && !hasCard) {
    items.push({ key: "payment", label: "payment details" });
  }
  return items;
}

export function isProfileSetupComplete(settings) {
  return getIncompleteSetupItems(settings).length === 0;
}

export function setupReminderDismissKey(userId) {
  return `kipabiz_setup_reminder_dismissed_${userId || "anon"}`;
}

export function isSetupReminderDismissed(userId) {
  if (typeof sessionStorage === "undefined") return false;
  return sessionStorage.getItem(setupReminderDismissKey(userId)) === "1";
}

export function dismissSetupReminder(userId) {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(setupReminderDismissKey(userId), "1");
}

export function clearSetupReminderDismiss(userId) {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(setupReminderDismissKey(userId));
}
